// features/landing/sections/verdictsCopy.ts — the two curated example verdicts
// and the sentences around them, as data.
//
// Both the landing page (VerdictsSection) and the sign-in page (AuthRecord)
// render from here, so the two surfaces can never drift and tell a visitor two
// different stories about how the Council writes. The strings are exactly what
// the landing page rendered before this module existed, whitespace collapsed
// the way JSX collapses it; nothing here is new copy.

export interface ExampleVerdict {
  outcome: 'kept' | 'removed';
  category: string;
  reasons: string;
}

/** Owner-approved, static, representative of real output. Not live data. */
export const VERDICT_EXAMPLES: ExampleVerdict[] = [
  {
    outcome: 'kept',
    category: 'Reported as: coordinated abuse',
    reasons:
      'The post is blunt criticism of a public figure, and several accounts sharing one opinion is not coordination. Being harsh, or being wrong, is not one of the five rules. Kept, 6–1.',
  },
  {
    outcome: 'removed',
    category: 'Reported as: scam',
    reasons:
      'The post promises guaranteed returns and routes readers to an off-platform wallet address: the exact pattern rule three names. The author may appeal with evidence the offer is real. Removed, 7–0.',
  },
];

export const VERDICTS_HEADING = 'Decisions read like this';

export const VERDICTS_INTRO =
  'Two example verdicts, written the way the Council writes them: outcome, vote, and the reasons in plain language. One keeps a post up; that is the point: most reports do not end in removal.';

export const VERDICTS_RECEIPTS_BEFORE =
  'These are examples. The real record (every case, every vote, every written reason) is public at ';
export const VERDICTS_RECEIPTS_LINK = 'the Council';
export const VERDICTS_RECEIPTS_AFTER = ', no account needed.';

/** The outcome word, sentence-cased for a sentence-case context. The same word
 *  the data carries, not new copy. */
export const OUTCOME_LABEL: Record<ExampleVerdict['outcome'], string> = {
  kept: 'Kept',
  removed: 'Removed',
};
